import { ENV_LIVE } from '@/utils/constants';
export const getPortalUrl = (brandId) => {
    const env = process.env.ENVIRONMENT;
    // eslint-disable-next-line sonarjs/no-small-switch
    switch (brandId) {
        case 'iwt':
            return env === ENV_LIVE
                ? `https://www.immowelt.de`
                : `https://${env}.immowelt.de`;
        default:
            throw new Error(`Brand ${brandId} is not supported`);
    }
};
